import React from "react";
import classNames from "classnames";
const TokenCard: React.FC<{ value: number | string; className?: string }> = ({
  value,
  className,
}) => {
  return (
    <div
      className={classNames(
        className,
        "flex flex-row w-36 items-center sm:p-1 p-1.5 rounded-lg border border-primary-1 gap-x-2 bg-black",
      )}
    >
      <div
        className="p-0.5 px-1 flex border border-white/60 rounded-md  items-center jusitfy-center "
        aria-label="logo"
      >
        <img
          src={
            "https://imagedelivery.net/LQsry4VlRw5rN4KvSzkcLw/e1b77ff5-8667-4e0b-678f-1fcaf5894300/public"
          }
          className="sm:h-3.5 h-3"
        />
      </div>
      <span className="sm:text-xs text-[10px] font-extrabold font-redhat-display text-white">
        {value}
      </span>
    </div>
  );
};

export default TokenCard;
